import * as React from 'react';
import { Field, Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Grid, Box } from '@material-ui/core';
import { notEmpty } from '@topconagriculture/forms';
import { validations } from '@topconagriculture/frontend-utils';
import { TextInput, Loading } from '@topconagriculture/react-components';
import { ModalActionButton, ModalActions, ModalContent, useModal } from '@topconagriculture/modal';
import { useDashboardAPI } from '../../../hooks/useDashboardContext';
import { useWidgetUpdateConfigMutation } from '../../../hooks/useWidgetUpdateConfigMutation';
import PlaceAutocomplete from './PlaceAutocomplete';
const WeatherChangeWidgetForm = () => {
    var _a, _b, _c;
    const { closeModal, modalParams } = useModal();
    const { t } = useTranslation();
    const api = useDashboardAPI();
    const { widget } = modalParams;
    const updateWidgetMutation = useWidgetUpdateConfigMutation();
    const onSubmitFn = async (values) => {
        const coordinates = await api.geocoding.getGeocodeByPlaceId(values.address.placeId);
        if (!coordinates) {
            return;
        }
        await updateWidgetMutation.mutateAsync({
            uuid: widget.uuid,
            config: {
                alias: values.alias,
                address: values.address.address,
                placeId: values.address.placeId,
                latitude: coordinates.latitude,
                longitude: coordinates.longitude,
            },
        });
        closeModal();
    };
    const notEmptyMemoized = React.useMemo(() => notEmpty({ t }), [t]);
    return (React.createElement(Form, { onSubmit: onSubmitFn, initialValues: {
            address: {
                address: ((_a = widget === null || widget === void 0 ? void 0 : widget.config) === null || _a === void 0 ? void 0 : _a.address) || '',
                placeId: ((_b = widget === null || widget === void 0 ? void 0 : widget.config) === null || _b === void 0 ? void 0 : _b.placeId) || '',
            },
            alias: ((_c = widget === null || widget === void 0 ? void 0 : widget.config) === null || _c === void 0 ? void 0 : _c.alias) || '',
        }, render: ({ handleSubmit, values, invalid }) => {
            var _a;
            return (React.createElement("form", { onSubmit: handleSubmit },
                React.createElement(ModalContent, null, updateWidgetMutation.isLoading ? (React.createElement(Box, { px: 6, py: 4 },
                    React.createElement(Loading, { isLoading: true }))) : (React.createElement(Grid, { container: true, spacing: 2 },
                    React.createElement(Grid, { item: true, xs: 12 }),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Field, { name: `address`, validate: (v, b) => validations.strings.notEmpty(v, b, { t }) }, ({ input }) => React.createElement(PlaceAutocomplete, { value: input.value, onChange: input.onChange }))),
                    React.createElement(Grid, { item: true, xs: 12 },
                        React.createElement(Field, { name: `alias`, required: true, disabled: ((_a = values.address) === null || _a === void 0 ? void 0 : _a.length) <= 0, validate: notEmptyMemoized }, ({ input }) => (React.createElement(TextInput, { fullWidth: true, label: t('widget:weather:alias'), placeholder: t('widget:weather:alias'), value: input.value, onChange: input.onChange }))))))),
                React.createElement(ModalActions, { closeModal: closeModal },
                    React.createElement(ModalActionButton, { disabled: invalid || updateWidgetMutation.isLoading, action: handleSubmit, btnLabel: t('common:save') }))));
        } }));
};
export default WeatherChangeWidgetForm;
//# sourceMappingURL=WeatherChangeWidgetForm.js.map